import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useCreateTraining } from '../../../api/hooks/useTrainings';
import { useOrganization } from '../../../contexts/OrganizationContext';

interface CreateTrainingModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (trainingId: string) => void;
}

const CreateTrainingModal: React.FC<CreateTrainingModalProps> = ({
  open,
  onClose,
  onSuccess,
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  
  const { selectedOrganization } = useOrganization();
  const { enqueueSnackbar } = useSnackbar();
  const createMutation = useCreateTraining(selectedOrganization?.id || '');

  const handleSubmit = async () => {
    if (!name.trim()) {
      enqueueSnackbar('El nombre es requerido', { variant: 'error' });
      return;
    }

    if (!selectedOrganization?.id) {
      enqueueSnackbar('No hay organización seleccionada', { variant: 'error' });
      return;
    }

    try {
      const result = await createMutation.mutateAsync({
        name: name.trim(),
        description: description.trim() || undefined,
        logo: logoUrl.trim() || undefined,
        organizationId: selectedOrganization.id,
        isActive: true,
      });

      enqueueSnackbar('Capacitación creada exitosamente', { variant: 'success' });
      handleClose();
      if (onSuccess && result.id) {
        onSuccess(result.id);
      }
    } catch (error) {
      enqueueSnackbar('Error al crear la capacitación', { variant: 'error' });
      console.error('Error creating training:', error);
    }
  };

  const handleClose = () => {
    setName('');
    setDescription('');
    setLogoUrl('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Crear Nueva Capacitación</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label="Nombre"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            fullWidth
            autoFocus
          />
          <TextField
            label="Descripción"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={3}
            fullWidth
          />
          <TextField
            label="URL del Logo (opcional)"
            value={logoUrl}
            onChange={(e) => setLogoUrl(e.target.value)}
            fullWidth
            placeholder="https://..."
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={createMutation.isPending}>
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={createMutation.isPending}
          startIcon={createMutation.isPending && <CircularProgress size={20} />}
        >
          Crear
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateTrainingModal;



